import { useCallback, useEffect, useState } from "react";
import { Table } from "antd";
import { useSearchParams } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { getAnalyticsLoans } from "services/MiscService";
import ChartsComp from "components/Home/HomeAnalytics/LgaChart";

export default function AnalyticsPage() {
    const [searchParams, setSearchParams] = useSearchParams();

    // Read from URL or set defaults
    const [search, setSearch] = useState(searchParams.get("search") || "");
    const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
    const [limit, setLimit] = useState(Number(searchParams.get("limit")) || 10);

    const [loading, setLoading] = useState(true);
    const [datasource, setDatasource] = useState([]);
    const [total, setTotal] = useState(0);

    const fetchAnalyticsLoan = useCallback(async () => {
        setLoading(true);

        try {
            const res = await getAnalyticsLoans({
                search,
                page,
                limit
            });

            if (res.data.loans) {
                setDatasource(res.data.loans);
                if(res?.data?.loans?.length){
                  setTotal(res.data.pagination.total);
                }
            }

            // Update URL params for persistence
            setSearchParams({
                search,
                page,
                limit
            });

        } finally {
            setLoading(false);
        }
    }, [search, page, limit, setSearchParams]);

    useEffect(() => {
        fetchAnalyticsLoan();
    }, [fetchAnalyticsLoan]);

    const tableColumns = [
        {
            fixed:"left",
            width:"200px",
            title: "Student Name",
            key: "student_name",
            render: (_, record) => (
                <p className="font-poppins text-xs lg:text-base">
                    {record?.applicant?.first_name} {record?.applicant?.middle_name} {record?.applicant?.surname}
                </p>
            )
        },
        {
            title: "LGA",
            key: "lga",
            width:"200px",
            render: (_, record) => <p className="font-poppins text-xs lg:text-base">{record?.applicant?.lga}</p>
        },
        {
            title: "Amount (₦)",
            dataIndex: "amount",
            width:"200px",
            key: "amount",
            render: v => <p className="font-poppins text-xs lg:text-base">₦{v.toLocaleString()}</p>
        },
        {
            title: "Institution",
            key: "institution",
            width:"200px",
            render: (_, record) => <p className="font-poppins text-xs lg:text-base">{record.institution?.name}</p>
        }
    ];

    return (
        <MainLayout>
            <div className="bg-secondary p-4 flex justify-center items-center min-h-screen">
                <div className="max-w-[800px] flex-1 mx-auto">
                    <ChartsComp/>
                </div>
            </div>
            <section className="p-4 lg:p-8 max-w-[1196px] mx-auto">
                {/* Search Bar */}
                <header className="bg-white my-8 flex items-center gap-x-4 p-3 lg:p-4 max-w-[500px] mx-auto shadow-sm border rounded">
                    <i className="bi bi-search text-gray-500"></i>
                    <input
                        placeholder="Search Student Name, LGA or Institution"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1); // Reset page when searching
                        }}
                        className="flex-1 text-xs lg:text-base w-full outline-none"
                    />
                    <button onClick={()=>setSearch("")} >
                        <i className="bi bi-x-lg"></i>
                    </button>
                </header>

                {/* Table Header */}
                <header className="flex items-center">
                    <p className="text-primary font-bold font-poppins mb-4 lg:text-xl">
                        Recent Loans
                    </p>
                    <button
                        disabled={loading}
                        className="bg-primary flex items-center justify-between gap-x-2 disabled:opacity-50 px-3 py-1 lg:px-4 lg:py-2 rounded-lg text-white ml-auto"
                        onClick={fetchAnalyticsLoan}
                    >
                       {loading
                       ? <i className="bi bi-arrow-clockwise animate-spin text-sm lg:text-2xl"></i>
                       : <i className="bi bi-arrow-clockwise text-sm lg:text-2xl"></i>}
                        <span>Refresh</span>
                    </button>
                </header>

                {search && (
                    <p className="font-poppins text-gray-500 text-sm"><b>{total}</b> item{total === 1?"":"s"} Found</p>
                )}
                {/* Table */}
                <div className="my-4 bg-white p-4 rounded shadow-sm">
                    <Table
                        columns={tableColumns}
                        dataSource={datasource}
                        rowKey="_id"
                        scroll={{
                            x:"max-screen"
                        }}
                        loading={loading}
                        pagination={{
                            current: page,
                            pageSize: limit,
                            total: total,
                            onChange: (newPage, newLimit) => {
                                setPage(newPage);
                                setLimit(newLimit);
                            }
                        }}
                    />
                </div>

            </section>
        </MainLayout>
    );
}
